import React from "react";
import { ConfigProvider, Switch, SwitchProps } from "antd";
import {
  FlexibleContainer,
  HorizontalLine,
  RowContainer,
} from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { compassLightGreen, lightGreyText } from "../../../styles";

export const SankeyControls = ({
  includeCorporateIssues,
  setIncludeCorporateIssues,
}: SankeyControls): JSX.Element => {
  return (
    <FlexibleContainer fd="column" ai="flex-start" w="250px">
      <RowContainer>
        <CompassParagraph fontSize={14}>Configuration</CompassParagraph>
      </RowContainer>
      <HorizontalLine marginBottom={4} marginTop={1} />
      <RowContainer>
        <CompassParagraph color={lightGreyText}>
          Include Corporate Issues
        </CompassParagraph>
      </RowContainer>
      <RowContainer mt={1}>
        <CustomSwitch
          checked={includeCorporateIssues}
          onChange={setIncludeCorporateIssues}
        />
      </RowContainer>
    </FlexibleContainer>
  );
};

export const CustomSwitch = (props: SwitchProps): JSX.Element => (
  <ConfigProvider
    theme={{
      components: {
        Switch: {
          handleBg: props.checked ? compassLightGreen : "white",
          trackMinWidth: 34,
          colorPrimary: "#CFFFEB",
          colorPrimaryHover: "#CFFFEB",
          handleShadow: "none",
        },
      },
    }}
  >
    <Switch {...props} />
  </ConfigProvider>
);

type SankeyControls = {
  isLoading: boolean;
  includeCorporateIssues: boolean;
  setIncludeCorporateIssues: (b: boolean) => void;
};
